<template>
    <el-dialog title="基础身份认证" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
        <div class="dialog-box">
            <el-form label-position="top" label-width="80px" :model="form">
                <el-form-item :label="$t('选择国籍')">
                    <el-select v-model="form.country_id" :placeholder="$t('请选择')" filterable style="width: 100%;">
                        <el-option v-for="item in countryList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('证件类型')">
                    <el-select v-model="form.type" :placeholder="$t('请选择')" style="width: 100%;">
                        <el-option v-for="item in typeList" :key="item.key" :label="item.value" :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('真实姓名')">
                    <el-input v-model="form.name" :placeholder="$t('请输入您本人的真实姓名')" size="medium" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('证件号码')">
                    <el-input v-model="form.id_number" :placeholder="$t('请输入证件号码')" size="medium" clearable></el-input>
                </el-form-item>
            </el-form>

            <div class="but" @click="submit">{{ $t('开始认证') }}</div>
        </div>
    </el-dialog>
</template>
<script>
import {
    get, post
} from '@/http/request'
import { mapState } from "vuex";
export default {
    props: {
    },
    computed: {
        ...mapState(["config"]),
        typeList() {
            const arr = [
                {
                    value: this.$t('身份证'),
                    key: 1,
                },
                {
                    value: this.$t('护照'),
                    key: 2,
                },
                {
                    value: this.$t('驾驶证'),
                    key: 3,
                },
            ]
            return this.config.identityType || arr
        },
    },
    data() {
        return {
            dialogVisible: false,
            form: {
                type: 1, //证件类型:1=身份证,2=护照,3=驾驶证
                country_id: '', // 国家id
                name: '', // 姓名
                id_number: '', // 证件号
            },

            countryList: [],
        };
    },
    watch: {
    },
    created() {
        this.getCountryList()
    },
    beforeUnmount() { },
    methods: {
        open() {
            this.dialogVisible = true
        },
        getCountryList() {
            get(this.$apis.getCountryList,
                // { showLoading: false }
            ).then(res => {
                if (res.code != 1) return
                this.countryList = res.data

                if (this.countryList.length > 0) {
                    this.form.country_id = this.countryList[0].id
                }
            })
        },
        submit() {
            if (!this.form.name) {
                this.$notify.error(this.$t('请输入姓名'))
                return
            }
            if (!this.form.id_number) {
                this.$notify.error(this.$t('请输入证件号码'))
                return
            }
            post(this.$apis.basicReal, this.form).then(res => {
                if (res.code != 1) return
                this.$notify.success(res.msg)
                this.dialogVisible = false
                this.$emit('success', false)
            })
        }
    },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
    padding-top: 10px;
}

::v-deep .el-dialog__title {
    color: #fff;
}

.dialog-box {
    .but {
        width: 100%;
        height: 36px;
        line-height: 36px;
        background: #f0c163;
        opacity: 1;
        border-radius: 5px;
        font-size: 16px;
        font-weight: 400;
        color: #fff;
        margin-top: 32px;
        text-align: center;
        cursor: pointer;
    }
}
</style>